import { useState, useCallback } from 'react';
import { useAppSelector } from '../../store/hooks';

/**
 * Hook to manage profile completion checks and modal
 * Only applies to Airliner users
 * @returns {Object} - { isModalOpen, openModal, closeModal, isProfileComplete }
 */
export const useProfileCompletion = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user } = useAppSelector((state) => state.auth);

  // Only check profile completion for Airliner users
  const isAirliner = user?.user_type === 'Airliner';
  const isProfileComplete = user?.is_profile_complete || false;

  const checkProfileCompletion = useCallback(() => {
    // Only enforce profile completion for Airliner users
    if (isAirliner && !isProfileComplete) {
      setIsModalOpen(true);
      return false;
    }
    // For non-Airliner users or complete profiles, allow access
    return true;
  }, [isAirliner, isProfileComplete]);

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return {
    isModalOpen,
    openModal,
    closeModal,
    isProfileComplete,
    checkProfileCompletion,
    isAirliner
  };
};

export default useProfileCompletion;
